import api from './api';

/**
 * Discriminated response from the unified public resolver.
 *
 * The backend resolves a slug against MenuShare first, then WineListShare,
 * and tags the payload with `kind` so the frontend can branch without an
 * extra round trip.
 */
export type PublicResolveResponse =
  | { kind: 'menu'; data: any }
  | { kind: 'wine-list'; data: any };

/**
 * Anonymous, public unified resolver. Hits the unauthenticated
 * /api/public/m/:slug endpoint.
 *
 * The `api` axios client may attach a stale auth token from localStorage if
 * the device has ever been logged in to admin — that's harmless: the public
 * endpoint ignores authentication entirely.
 */
const publicResolveService = {
  getBySlug: async (slug: string): Promise<PublicResolveResponse> => {
    const response = await api.get(`/public/m/${encodeURIComponent(slug)}`);
    return response.data;
  },
};

export default publicResolveService;
